import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { RfpProOfferPaymentOptionText } from '@/components/modules/pages/rfp/professional/Typography/Body/RfpProOfferPaymentOptionText/RfpProOfferPaymentOptionText';
import { RFP_PAYMENT_OPTION_TEN_PERCENT } from '@/utils/constants/rfp/paymentOption';
import { getPaymentFee } from '@/utils/resources/rfp/rfpOfferPaymentOption';
/**
 * コンサルタント案件詳細: 支払い方法表示テキスト
 * @param props
 * @returns
 */
export const RfpProOfferPaymentOptionsText = (props) => {
    const { budget, options, paymentOption, price } = props;
    const fee = useMemo(() => getPaymentFee({
        budget,
        paymentOption: options,
        price: budget !== null && budget !== void 0 ? budget : price,
    }), [budget, price, options]);
    // 支払い方法を選択する必要がなかった場合
    if (paymentOption.length < 2) {
        return (_jsx("span", { children: _jsx(RfpProOfferPaymentOptionText, { paymentOption: paymentOption[0] }) }));
    }
    // 支払い方法の選択肢が2つ以上ある時
    return (_jsxs("span", Object.assign({ className: 'inline-flex gap-x-20' }, { children: [_jsx("span", Object.assign({ className: 'shrink-0' }, { children: _jsx(RfpProOfferPaymentOptionText, { isShort: true, paymentOption: options }) })), options === RFP_PAYMENT_OPTION_TEN_PERCENT.value ? (
            // 成果報酬の場合はテキスト表記
            _jsx("span", { children: _jsx(RfpProOfferPaymentOptionText, { paymentOption: options }) })) : (
            // 成果報酬でない場合は金額表記
            _jsx("span", { children: `${fee}円（税込）` }))] })));
};
